/**
 * Tipos de documento de identidad — compartido entre el signup (selector)
 * y la cuenta (label read-only). ROUND10.
 */
export const DOCUMENT_TYPES = [
  { value: 'CC', label: 'Cédula de ciudadanía' },
  { value: 'CE', label: 'Cédula de extranjería' },
  { value: 'PA', label: 'Pasaporte' },
  { value: 'NIT', label: 'NIT' },
] as const;

export type DocumentTypeValue = (typeof DOCUMENT_TYPES)[number]['value'];

/** Etiqueta legible de un tipo de documento a partir de su código. */
export function documentTypeLabel(value: string | null | undefined): string {
  if (!value || !value.trim()) return '—';
  const found = DOCUMENT_TYPES.find((d) => d.value === value.trim().toUpperCase());
  return found ? found.label : value;
}
